// routes/routes.jsx
import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../context/Auth/AuthContext';
import BackdropLoading from '../components/BackdropLoading';

const PrivateRoute = () => {
  const { isAuth, loading } = useContext(AuthContext);

  if (loading) {
    return <BackdropLoading />;
  }

  return isAuth ? <Outlet /> : <Navigate to='/login' replace />;
};

export default PrivateRoute;
